<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="closeDialog()" @keydown.esc="closeDialog()" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-on:submit.prevent="importar($event)">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text style="margin-bottom: 80px">
            <!-- START FORM DIALOG -->
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col md="10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
                <a-steps :current="step">
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
              </v-col>
            </v-row>

            <div class="steps-content">
              <!--step 0-->
              <v-row align="start" justify="center" v-if="step == 0" transition="fade-transition">
                <v-col md="6" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step0" class="form-step0-excel">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[0].title }}</b>
                      </p>
                    </div>
                    <v-label>
                      Descargar la plantilla de importación de reglas de reposición.
                      <v-label @click="downloadExcel" class="text-download font-weight-bold ms-1 me-1"> Descargar </v-label>
                    </v-label>

                    <v-alert type="info" density="compact" variant="tonal" class="mt-3">
                      Cargá una fila por ubicación. Las filas con el mismo Cliente, Almacén y SKU se agrupan en una sola regla.
                    </v-alert>

                    <v-file-input
                      class="mt-3"
                      accept=".xlsx"
                      label="Seleccionar excel"
                      v-model="excelFile"
                      hint="Solo admite archivos formato .xlsx (No admite formato .xls)"
                      persistent-hint
                    ></v-file-input>
                  </v-form>
                </v-col>
              </v-row>

              <!--step 1-->
              <v-row align="start" justify="center" v-if="step == 1" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step1">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[1].title }}</b>
                      </p>
                    </div>
                    <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important" class="mb-3 mt-3">
                      <strong>{{ Math.ceil(percent) || 0 }}%</strong>
                    </v-progress-linear>

                    <v-data-table :headers="headers" :items="list_bulk" :search="search" :loading="loading_table" class="expandable-rows" :items-per-page="10" hide-default-footer dense>
                      <template v-slot:item="{ item }">
                        <tr>
                          <td class="expand-icon" @click="toggleExpand(item.object.key)">
                            <v-icon>
                              {{ expandedRows.includes(item.object.key) ? "mdi-chevron-up" : "mdi-chevron-down" }}
                            </v-icon>
                          </td>
                          <td>{{ item.object.client.name }}</td>
                          <td>{{ item.object.almacen.name }}</td>
                          <td>{{ item.object.product.sku }}</td>
                          <td class="text-center">{{ item.object.stock_min }}</td>
                          <td class="text-center">{{ item.object.stock_max }}</td>
                          <td class="text-center">{{ item.object.locations_arr.length }}</td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg == '' && !item.status_create">
                            <i class="fa fa-check text-green"></i>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg != '' && !item.status_create">
                            <span class="text-red">{{ item.msg }}</span>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.status_create">
                            <span class="text-green">Importado</span>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 0 && item.msg != ''">
                            <span class="text-red">{{ item.msg }}</span>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 0 && item.msg == ''">
                            {{ "Pendiente de procesado" }}
                          </td>
                          <td style="min-width: 200px" v-if="item.loading">Procesando...</td>
                        </tr>
                        <tr v-if="expandedRows.includes(item.object.key)">
                          <td :colspan="headers.length" class="pl-0 pr-0">
                            <v-data-table class="custom-subtable" :headers="headers_locations" :items="item.object.locations_arr" hide-default-footer disable-pagination style="background-color: #ccc">
                              <template v-slot:item="{ item }">
                                <tr>
                                  <td>{{ item.code }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-form>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions style="position: fixed; bottom: 0; right: 0; left: 0">
            <v-row align="start" justify="center">
              <v-col cols="10" style="background-color: white">
                <v-btn @click="prev" color="blue-grey" variant="outlined" v-if="step > 0">Atras</v-btn>
                <div class="float-right mr-2" v-if="step == 1">
                  <v-chip color="success" class="mr-2">Importadas: {{ importaciones_creadas }}</v-chip>
                  <v-chip color="error" class="">Fallidas: {{ importaciones_no_creadas }}</v-chip>
                  <v-btn v-if="importaciones_no_creadas > 0" @click="downloadErrorsExcel" color="error" variant="outlined" size="small" class="ml-3"> Descargar Errores </v-btn>
                </div>

                <v-btn class="float-right" variant="outlined" color="primary" @click="readExcel" v-if="step == 0" :disabled="excelFile == null && step == 0"> Siguiente</v-btn>
              </v-col>
              <v-col cols="12" style="background-color: #fafafa; border-top: 1px solid #c1c1c1" class="text-end">
                <v-btn color="error" text @click="closeDialog()">Cerrar</v-btn>
                <v-btn color="success" text type="submit" :disabled="submit_disabled" :loading="loading" v-if="!disabled && step == 1">{{ formBtn }}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import readXlsxFile from "read-excel-file";
import { REPOSICION_RULE_COLUMNS } from "@/constants/ExcelColumnMappings";

export default {
  components: {},
  mixins: [ValidMixin, ExportMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      step: 0,
      search: "",
      headers: [
        {},
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "object.client.name",
        },
        {
          title: "Almacén",
          align: "left",
          sortable: true,
          key: "object.almacen.name",
        },
        {
          title: "SKU",
          align: "left",
          sortable: true,
          key: "object.product.sku",
        },
        {
          title: "Stock mínimo",
          align: "center",
          sortable: true,
          key: "object.stock_min",
        },
        {
          title: "Stock máximo",
          align: "center",
          sortable: true,
          key: "object.stock_max",
        },
        {
          title: "Ubicaciones",
          align: "center",
          sortable: false,
          key: "",
        },
        {
          title: "Resultado",
          align: "left",
          sortable: false,
          key: "msg",
        },
      ],
      headers_locations: [{ title: "Ubicación", key: "code", sortable: false }],
      steps: [
        {
          title: "Importar Excel",
          description: "Importe el Excel",
          content: "First-content",
        },
        {
          title: "Detalle del Excel",
          description: "Detalle del Excel",
          content: "Second-content",
        },
      ],
      excelFile: null,
      list_bulk: [],
      expandedRows: [],
      loading_create: false,
      importaciones_creadas: 0,
      importaciones_no_creadas: 0,
      total_importaciones: 0,
      submit_disabled: false,
      progress: 0,
      loading_table: false,
    };
  },
  watch: {},
  mounted() {},

  computed: {
    percent: {
      get() {
        return ((this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
  },

  methods: {
    downloadExcel() {
      const params = {};
      const fileName = "plantilla_reglas_reposicion.xlsx";

      this.exportExcel(this.service.section + "/get-sample-excel", params, fileName);
    },
    getProcesadosValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && element.status_create).length;
    },
    getProcesadosNoValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && !element.status_create).length;
    },

    toggleExpand(id) {
      if (this.expandedRows.includes(id)) {
        this.expandedRows = this.expandedRows.filter((rowId) => rowId !== id);
      } else {
        this.expandedRows.push(id);
      }
    },
    async readExcel() {
      this.step++;
      this.list_bulk = [];
      this.loading_table = true;
      try {
        const rows = await readXlsxFile(this.excelFile, {
          sheet: 1,
          dateFormat: "YYYY-MM-DD",
        });

        // El Excel trae una ubicacion por fila, pero una regla es producto + almacen + N
        // ubicaciones: se agrupan las filas antes de armar la lista que se va a importar.
        const groups = this.groupRows(rows.slice(1));

        groups.forEach((group) => {
          this.list_bulk.push({
            object: this.parseObject(group),
            //Los errores detectados al leer el Excel (datos incompletos o inconsistentes entre
            //filas del mismo grupo) ya vienen resueltos: esa regla no se manda al backend.
            msg: group.msg,
            status: 0,
            status_create: false,
            loading: false,
          });
        });

        this.total_importaciones = this.list_bulk.length;

        if (this.list_bulk.length == 0) {
          this.toast.warning("El Excel no tiene filas para importar");
        }
      } catch (error) {
        console.error(error);
        this.toast.error("Error al leer el archivo Excel");
      } finally {
        this.loading_table = false;
      }
    },

    /**
     * Agrupa las filas del Excel por Cliente + Almacén + SKU y valida la coherencia dentro de
     * cada grupo. Devuelve un array de grupos en el orden en que aparecen en el Excel.
     */
    groupRows(rows) {
      const groups = new Map();

      rows.forEach((element, index) => {
        const client_name = this.cellToString(element[REPOSICION_RULE_COLUMNS.CLIENTE]);
        const almacen_name = this.cellToString(element[REPOSICION_RULE_COLUMNS.ALMACEN]);
        const sku = this.cellToString(element[REPOSICION_RULE_COLUMNS.SKU]);
        const ubicacion_code = this.cellToString(element[REPOSICION_RULE_COLUMNS.UBICACION]);
        const stock_min = this.cellToInt(element[REPOSICION_RULE_COLUMNS.STOCK_MIN]);
        const stock_max = this.cellToInt(element[REPOSICION_RULE_COLUMNS.STOCK_MAX]);

        //Excel suele traer filas en blanco al final del rango usado: se descartan
        if (client_name === "" && almacen_name === "" && sku === "" && ubicacion_code === "" && stock_min === null && stock_max === null) return;

        //+2: una por el header y otra porque Excel numera desde 1. Sirve para que el mensaje
        //de error apunte a la fila real del archivo.
        const excel_row = index + 2;
        const key = client_name.toLowerCase() + "|" + almacen_name.toLowerCase() + "|" + sku.toLowerCase();

        if (!groups.has(key)) {
          groups.set(key, {
            key: key,
            client_name: client_name,
            almacen_name: almacen_name,
            sku: sku,
            stock_min: stock_min,
            stock_max: stock_max,
            locations_arr: [],
            location_codes: [],
            msg: "",
          });
        }

        const group = groups.get(key);

        if (client_name === "") this.setGroupError(group, "Fila " + excel_row + ": falta el cliente.");
        if (almacen_name === "") this.setGroupError(group, "Fila " + excel_row + ": falta el almacén.");
        if (sku === "") this.setGroupError(group, "Fila " + excel_row + ": falta el SKU.");
        if (ubicacion_code === "") this.setGroupError(group, "Fila " + excel_row + ": falta la ubicación.");

        if (stock_min === null || stock_min < 0) this.setGroupError(group, "Fila " + excel_row + ": el stock mínimo debe ser un número entero mayor o igual a 0.");
        if (stock_max === null || stock_max < 1) this.setGroupError(group, "Fila " + excel_row + ": el stock máximo debe ser un número entero mayor a 0.");
        if (stock_min !== null && stock_max !== null && stock_max <= stock_min) this.setGroupError(group, "Fila " + excel_row + ": el stock máximo debe ser mayor al stock mínimo.");

        //Todas las filas de la misma regla tienen que declarar el mismo min/max: si no coinciden
        //no hay forma de saber cual vale, asi que la regla entera queda en error.
        if (group.stock_min !== stock_min || group.stock_max !== stock_max)
          this.setGroupError(group, "Fila " + excel_row + ": el stock mínimo/máximo no coincide con el de las otras filas del mismo cliente, almacén y SKU.");

        //Una ubicacion repetida dentro de la misma regla no es un error: se ignora la repetida
        if (ubicacion_code !== "" && !group.location_codes.includes(ubicacion_code.toLowerCase())) {
          group.location_codes.push(ubicacion_code.toLowerCase());
          group.locations_arr.push({ code: ubicacion_code });
        }
      });

      return Array.from(groups.values());
    },

    //Solo se guarda el primer error del grupo: alcanza para que el usuario sepa que corregir
    //y evita mensajes larguisimos en la columna Resultado.
    setGroupError(group, msg) {
      if (group.msg === "") group.msg = msg;
    },

    cellToString(value) {
      if (value === null || value === undefined) return "";
      return value.toString().trim();
    },

    cellToInt(value) {
      if (value === null || value === undefined || value === "") return null;
      const parsed = Number(value.toString().trim());
      if (isNaN(parsed) || !Number.isInteger(parsed)) return null;
      return parsed;
    },

    parseObject(group) {
      return {
        //key: identifica al grupo en la tabla expandible (equivale al cabecera_num de otros Excel)
        key: group.key,
        client_name: group.client_name,
        almacen_name: group.almacen_name,
        sku: group.sku,
        stock_min: group.stock_min,
        stock_max: group.stock_max,
        locations_arr: group.locations_arr,

        // Para mostrar en la tabla
        client: { name: group.client_name },
        almacen: { name: group.almacen_name },
        product: { sku: group.sku },
      };
    },

    closeDialog() {
      this.$emit("updateDialog", false);
      this.resetForm();
    },

    resetForm() {
      this.step = 0;
      this.list_bulk = [];
      this.excelFile = null;
      this.expandedRows = [];
      this.importaciones_creadas = 0;
      this.importaciones_no_creadas = 0;
      this.total_importaciones = 0;
      this.submit_disabled = false;
      this.loading = false;
      this.loading_create = false;
      this.loading_table = false;

      // Reset forms si existen
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      if (this.$refs.form_step0) {
        this.$refs.form_step0.reset();
      }
      if (this.$refs.form_step1) {
        this.$refs.form_step1.reset();
      }
    },
    prev() {
      this.step--;
    },

    async importar() {
      this.loading_create = true;
      this.submit_disabled = true;

      for (let index = 0; index < this.list_bulk.length; index++) {
        if (this.list_bulk[index].status != 0 || this.list_bulk[index].status_create) continue;

        //Reglas que ya fallaron al leer el Excel: no se mandan al backend pero cuentan como fallidas
        //asi entran en el contador, en la barra de progreso y en el Excel de errores.
        if (this.list_bulk[index].msg != "") {
          this.list_bulk[index].status = 1;
          this.list_bulk[index].status_create = false;
          this.importaciones_no_creadas++;
          continue;
        }

        this.list_bulk[index].loading = true;
        let result = await this.createItem(this.list_bulk[index].object);

        this.list_bulk[index].loading = false;
        this.list_bulk[index].status = 1;
        this.list_bulk[index].status_create = result.status;
        this.list_bulk[index].msg = result.msg;

        if (result.status) {
          this.importaciones_creadas++;
        } else {
          this.importaciones_no_creadas++;
        }
      }

      this.loading_create = false;

      if (this.importaciones_creadas === this.list_bulk.length) {
        this.$emit("updateDialog", false);
        this.resetForm();
        this.$emit("loadList");
      }
    },
    async createItem(item) {
      try {
        const response = await this.service.import_line_excel({
          client_name: item.client_name,
          almacen_name: item.almacen_name,
          sku: item.sku,
          stock_min: item.stock_min,
          stock_max: item.stock_max,
          locations_arr: item.locations_arr,
        });
        return {
          status: response.status,
          msg: response.msg || (response.status ? "Importación exitosa" : "Error en la importación"),
        };
      } catch (error) {
        return {
          status: false,
          msg: error.response?.data?.msg || error.message || "Error en la importación",
        };
      }
    },

    downloadErrorsExcel() {
      const errorsData = this.list_bulk.filter((item) => item.status === 1 && !item.status_create && item.msg !== "");

      if (errorsData.length === 0) {
        this.toast.warning("No hay errores para exportar");
        return;
      }

      // Transformar los datos para el backend
      const formattedErrors = errorsData.map((item) => ({
        object: item.object,
        msg: item.msg,
      }));

      const params = {
        errors_data: formattedErrors,
      };
      const fileName = `errores_importacion_reglas_reposicion.xlsx`;

      this.exportExcel(this.service.section + "/get-excel-with-errors", params, fileName);
    },
  },
};
</script>
